<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>
    <div class="row"></div>
    <div v-if="campaignData !== null">
      <div :value="displayAlert" :color="alertType">{{ alertMsg }}</div>

      <div class="row">
        <div class="col-md-5">
          <div class="row">
            <div>
              <p-button
                outline
                type="info"
                size="sm"
                round
                @click="$router.go(-1)"
              >
                <i class="fa fa-chevron-circle-left"></i>
                Back
              </p-button>
            </div>
            <div>
              <h4 style="margin-top: 5px; margin-left: 10px">
                {{ campaignData.name }}
              </h4>
            </div>
          </div>
        </div>
        <div
          class="col-md-3 ml-auto"
          style="text-align: right; margin-right: 15px"
        >
          <p-button
            @click="showAddInfluencerModal"
            style="margin-top: 25px"
            link
            >+ Add Influencer</p-button
          >
        </div>
      </div>
      <div v-if="setStatus.length > 0">
        <div>{{ setStatus.length }} Influencers Selected</div>
        <div>
          <p-button @click="approveModal = true" round type="success"
            >Approve</p-button
          >
          <p-button @click="rejectModal = true" round type="danger"
            >Reject</p-button
          >
        </div>
      </div>
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="row">
            <div class="category col" v-if="candidateListData !== null">
              {{ candidateListData.count }} Candidates
            </div>
            <div class="col-md-8 ml-auto">
              <div style="padding: 10px; float: right; width: 300px">
                Search Profiles:
                <fg-input
                  class="input-sm"
                  placeholder="Search"
                  v-model="searchQuery"
                  addon-right-icon="nc-icon nc-zoom-split"
                  @keyup="searchFilter"
                ></fg-input>
              </div>

              <div style="padding: 10px; float: right; width: 300px">
                Show:
                <select
                  v-model="listView"
                  class="custom-select"
                  @change="toggleStatusView"
                >
                  <option value selected>view by influencer status</option>
                  <option
                    v-for="option in ['all', 'approved', 'pending', 'rejected']"
                    :value="option"
                    :key="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body row table-full-width" style="padding: 25px">
          <el-table
            :data="campaignCandidateList"
            class="table-striped"
            stripe
            border
            style="width: 100%"
          >
            <el-table-column
              label="Select"
              style="text-align: center; width: 80px"
            >
              <template slot-scope="props">
                <div style="width: 50px; text-align: center">
                  <input
                    type="checkbox"
                    :value="props.row._id"
                    v-model="setStatus"
                    class="chk-box"
                    style="margin-left: auto; margin-right: auto"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Instagram"
              style="text-align: center; max-width: 150px"
            >
              <template slot-scope="props">
                <div style="text-align: center; width: 100%">
                  <a
                    :href="
                      'https://instagram.com/' +
                      props.row.fullProfile.profileName
                    "
                    target="_blank"
                  >
                    <img
                      :src="props.row.fullProfile.profilePicCache"
                      class="influencer-img"
                      v-if="
                        typeof props.row.fullProfile.profilePicCache !==
                        'undefined'
                      "
                    />

                    <img
                      :src="props.row.fullProfile.profilePic"
                      class="influencer-img"
                      @error="
                        profilePicLoadCache(props.row.fullProfile.profileName)
                      "
                      v-else
                    />
                  </a>
                  <br />
                  <a
                    :href="
                      'https://instagram.com/' +
                      props.row.fullProfile.profileName
                    "
                    target="_blank"
                    >@{{ props.row.fullProfile.profileName }}</a
                  >
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="Bio" property="fullProfile.bio" style="width: 200px; font-size: 10px;"></el-table-column> -->
            <el-table-column
              label="Followers"
              property="fullProfile.followerCount"
              style="padding-left: 25px"
            ></el-table-column>
            <el-table-column label="ER" style="max-width: 50px">
              <template slot-scope="props"
                >{{
                  (props.row.fullProfile.engagementRate * 100).toFixed(2)
                }}%</template
              >
            </el-table-column>
            <el-table-column label="Date Added" style="max-width: 50px">
              <template slot-scope="props">{{
                props.row.dateAddedString
              }}</template>
            </el-table-column>
            <!-- <el-table-column label="Email" property="fullProfile.email " style="width: 100px;"></el-table-column> -->
            <el-table-column
              label="Status"
              property="status"
              style="width: 80px; padding-left: 25px"
            >
              <template slot-scope="props">
                <span v-if="props.row.status == 'pending'">
                  <badge type="danger">{{ props.row.status }}</badge>
                </span>
                <span v-if="props.row.status == 'approved'">
                  <badge type="success">{{ props.row.status }}</badge>
                </span>
                <span v-if="props.row.status == 'rejected'">
                  <badge type="default">{{ props.row.status }}</badge>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Actions" class-name="action-buttons td-actions" width="300">
              <template slot-scope="props">
                <p-button link type="info" round outline size="sm"
                  @click="$router.push('/influencer-campaign/influencer/' + props.row._id)">
                  DETAILS
                </p-button>                
                <p-button link type="info" round outline size="sm"
                  @click="$router.push('/influencer-campaign/content-list/' + campaignId + '/' + props.row._id)">
                  Content
                </p-button>                
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body row">
          <div class="col-sm-6"></div>
          <div class="col-sm-6">
            <div class="pull-right"></div>
          </div>
          <div class="col-sm-12 mt-2"></div>
          <!-- <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
            <div class="col-sm-6">
              <div class="btn-group" data-toggle="buttons">
                <p-button type="info" round outline>1</p-button>
                <p-button type="info" round outline>2</p-button>
                <p-button type="info" round outline>3</p-button>
                <p-button type="info" round outline>4</p-button>
              </div>
            </div>
          </div>-->
        </div>
      </div>

      <div v-if="campaignCandidateList !== null">
        <div v-if="campaignCandidateList.length > 0">
          <hr />

          <div class="row">
            <div class="col-md-5">
              <h4
                style="margin-top: 5px; margin-left: 10px"
                v-if="
                  typeof $route.query.q != 'undefined' && $route.query.q != ''
                "
              >
                Results for @{{ $route.query.q }}
              </h4>
              <p style="padding-left: 15px">
                {{ candidateListData.count }} results Page {{ currentPage }} of
                {{ pageCount }}
              </p>
            </div>
          </div>
          <div class="row" v-if="paginationArray.length > 1">
            <div class="col-md-12">
              <span v-if="prevPage !== null">
                <p-button
                  v-if="currentPage > 1"
                  @click="pageNavigation(currentPage - 1)"
                >
                  <i class="fas fa-angle-double-left"></i> prev
                </p-button>
              </span>

              <span v-for="page in paginationArray" :key="page">
                <p-button v-if="page == currentPage">{{ page }}</p-button>
                <p-button v-else @click="pageNavigation(page)">{{
                  page
                }}</p-button>
              </span>
              <span v-if="nextPage !== null">
                <p-button
                  v-if="currentPage < pageCount"
                  @click="pageNavigation(currentPage + 1)"
                >
                  <i class="fas fa-angle-double-right"></i> next
                </p-button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <modal
        :show.sync="approveModal"
        :show-close="false"
        :show-header="false"
        type="mini"
      >
        <h4 style="text-align: center">
          Approve {{ setStatus.length }} influencers?
        </h4>

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="approveSelected"
              style="margin: 10px"
              >Yes</p-button
            >
            <p-button
              round
              text
              @click="approveModal = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <modal
        :show.sync="rejectModal"
        :show-close="false"
        :show-header="false"
        type="mini"
      >
        <h4 style="text-align: center">
          Reject {{ setStatus.length }} influencers?
        </h4>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="rejectSelected"
              style="margin: 10px"
              >Yes</p-button
            >
            <p-button
              round
              text
              @click="rejectModal = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <modal :show.sync="addInfluencerModal" type="notice">
        <div v-if="addInfluencerAlert == true" class="error-modal">
          {{ addInfluencerAlertMsg }}
        </div>

        <h5 slot="header" class="modal-title">
          Add Influencer to {{ campaignData.name }}
        </h5>
        <fg-input
          label="Instagram Profile"
          id="instagram"
          name="instagram"
          type="text"
          v-model="model.newInfluencer"
          v-validate="modelValidations.newInfluencer"
          :error="getError('instagram')"
          data-vv-validate-on="blur"
          required
        ></fg-input>

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="addInfluencer"
              style="margin: 10px"
              >Yes</p-button
            >
            <p-button
              round
              text
              @click="cancelAddInfluencer"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import numeral from "numeral";
import IGProfileData from "@/libs/ig/profileData";
import PPagination from "@/components/UIComponents/Pagination.vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import {
  influencerCampaignSearchApi,
  influencerCampaignReadApi,
  influencerCampaignCandidateListApi,
  influencerCampaignCandidateAddApi,
  influencerCandidateUpdateStatusBatchApi,
  instagramProfileCacheApi,
} from "@/config/appSettings";
import { Badge, Modal } from "@/components/UIComponents";
import _ from "underscore";

export default {
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      try {
        this.pagination.total = this.tableData.length;
        return this.tableData.length;
      } catch (err) {
        console.log("ThER WAS AN ERROR:", err);
      }
    },
  },
  data: () => ({
    loadingOverlay: false,
    loadingText: null,
    campaigns: null,
    listView: null,
    campaignData: null,
    campaignId: null,
    candidatesAll: [],
    campaignCandidateList: null,
    candidateListData: null,
    addInfluencerModal: false,
    instagram: null,
    newInstagram: null,
    alertMsg: null,
    alertType: null,
    displayAlert: false,
    approveModal: false,
    rejectModal: false,
    addInfluencerAlert: null,
    addInfluencerAlertMsg: null,
    searchQuery: null,
    setStatus: [],
    pageCount: null,
    adCount: null,
    currentPage: 1,
    paginationArray: [],
    nextPage: null,
    prevPage: null,
    igRules: [(v) => !!v || "Enter a valid Instagram profile"],
    model: {
      newInfluencer: null,
    },
    modelValidations: {
      newInfluencer: {
        required: true,
        min: 1,
        instagramCheck: true,
      },
    },
    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      total: 0,
    },
    searchQuery: "",
    propsToSearch: ["instagram"],
    tableColumns: [
      {
        prop: "instagramProfile",
        label: "Instagram",
        minWidth: 200,
      },
      {
        prop: "fullProfile.followerCount",
        label: "Followers",
        minWidth: 250,
      },
      {
        prop: "fullProfile.engagementRate",
        label: "ER",
        minWidth: 100,
      },
      {
        prop: "status",
        label: "Status",
        minWidth: 120,
      },
    ],
    tableData: null,
  }),
  name: "InfluencerCandidateList",
  components: {
    Badge,
    Modal,
    PPagination,
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    /*validate() {
      this.$validator.validateAll().then((isValid) => {
        console.log("CHECKING IS VALID:", isValid);
        console.log("CHECKING REGISTER FORM: ", this.registerForm);
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },*/
    async profilePicLoadCache(instagramProfile) {
      let profileCacheUrl = `${instagramProfileCacheApi}/?usertoken=${this.auth}&instagram=${instagramProfile}`;
      //console.log("PROFILE CACHE:", profileCacheUrl);
      let profileCacheResponse = await axios.get(profileCacheUrl);
      //console.log(`LOADING ${instagramProfile}`, profileCacheResponse.data);
    },

    async searchFilter() {
      try {
        this.searchQuery = this.searchQuery.trim();
        if (this.searchQuery !== null && this.searchQuery.length > 1) {
          this.searchQuery = this.searchQuery.replace("@", "");
          this.campaignCandidateList = this.candidatesAll.map((x) => {
            if (x.instagramProfile.indexOf(this.searchQuery) !== -1) {
              return x;
            }
            return [];
          });
          this.campaignCandidateList = _.flatten(this.campaignCandidateList);
          //console.log("THIS CAMPAIGN LIST:", this.campaignCandidateList);
          return;
        }
        this.toggleStatusView();
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async toggleStatusView() {
      try {
        //console.log("LIST VIEW CHANGE:", this.listView);
        //console.log("LIST AVAILABLE:", this.candidatesAll);
        this.campaignCandidateList = this.candidatesAll;
        if (this.listView == "all") {
          this.campaignCandidateList = this.candidatesAll;
          if (typeof this.$route.query.view !== "undefined") {
            this.$router.push(
              `/influencer-campaign/list/${this.$route.params.campaignId}`
            );
          }
        }
        if (this.listView == "pending") {
          this.campaignCandidateList = this.candidatesAll.filter((x) => {
            return x.status == this.listView;
          });
          if (typeof this.$route.query.view !== "pending") {
            this.$router.push(
              `/influencer-campaign/list/${this.$route.params.campaignId}/?view=pending`
            );
          }
        }
        if (this.listView == "approved") {
          this.campaignCandidateList = this.candidatesAll.filter((x) => {
            return x.status == this.listView;
          });
          if (typeof this.$route.query.view !== "approved") {
            this.$router.push(
              `/influencer-campaign/list/${this.$route.params.campaignId}/?view=approved`
            );
          }
        }
        if (this.listView == "rejected") {
          this.campaignCandidateList = this.candidatesAll.filter((x) => {
            return x.status == this.listView;
          });
          if (typeof this.$route.query.view !== "rejected") {
            this.$router.push(
              `/influencer-campaign/list/${this.$route.params.campaignId}/?view=rejected`
            );
          }
        }
        await this.loadInfluencerCandidates();
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadCampaignList() {
      try {
        this.loadingOverlay = true;
        let influencerCandidateListUrl = `${influencerCampaignCandidateListApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`;

        let influencerCampaignList = await axios.get(
          influencerCandidateListUrl
        );
        //console.log("CAMPAIGN DATA: ", influencerCampaignList.data);
        if (influencerCampaignList.data.success === true) {
          this.campaigns = influencerCampaignList.data.result;
          this.loadingOverlay = false;
        }
      } catch (err) {
        //console.log(err);
      }
    },
    async loadCampaign() {
      this.loadingOverlay = true;
      this.loadingText = "LOADING CAMPAIGN...";

      //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
      let campaignLoadResponse = await axios.get(
        `${influencerCampaignReadApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`
      );
      /*console.log(
        "HERE IS THE CAMPAIGN LOAD RESPONSE:",
        campaignLoadResponse.data
      );*/
      if (campaignLoadResponse.data.success === true) {
        this.campaignData = campaignLoadResponse.data.result;
        this.loadInfluencerCandidates();
        //this.loadingOverlay = false;
        //this.loadingText = null;
        return;
      }
      this.loadingText = "There was an error loading. Refresh page.";
    },
    async loadInfluencerCandidates() {
      try {
        this.loadingOverlay = true;
        //this.loadingText = "LOADING INFLUENCERS...";

        let influencerCandidateListUrl = `${influencerCampaignCandidateListApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`;
        if (typeof this.$route.query.view !== "undefined") {
          influencerCandidateListUrl = `${influencerCandidateListUrl}&status=${this.$route.query.view}`;
        }
        if (typeof this.$route.query.page !== "undefined") {
          influencerCandidateListUrl = `${influencerCandidateListUrl}&page=${this.$route.query.page}`;
        }
        /*console.log(
          "INFLUENCER CANDIDATE LIST URL:",
          influencerCandidateListUrl
        );*/
        let influencerCandidateLoadResponse = await axios.get(
          influencerCandidateListUrl
        );
        /*
        console.log(
          "HERE IS THE CANDIDATE LIST RESPONSE:",
          influencerCandidateLoadResponse.data
        );*/
        if (influencerCandidateLoadResponse.data.success === true) {
          this.candidatesAll = influencerCandidateLoadResponse.data.result;
          this.candidateListData = influencerCandidateLoadResponse.data;
          this.candidatesAll = _.sortBy(
            this.candidatesAll,
            "dateAdded"
          ).reverse();
          this.campaignCandidateList = this.candidatesAll;
          if (this.$route.query.view !== "rejected") {
            this.campaignCandidateList = this.candidatesAll.filter((x) => {
              return x.status !== "rejected";
            });
          }

          let candidateCount = influencerCandidateLoadResponse.data.count;
          this.pageCount = Math.floor(candidateCount / 50) + 1;
          //console.log("PAGE COUNT:", this.pageCount);
          this.currentPage = 1;
          if (!isNaN(this.$route.query.page)) {
            this.currentPage = Number(this.$route.query.page);
          }
          this.paginationArray = [];
          this.paginationArray.push(this.currentPage);
          //console.log("PAGINATION ARRAY CLEAN:", this.paginationArray);
          if (this.pageCount > 1) {
            var i;
            for (i = this.currentPage + 1; i < this.currentPage + 3; i++) {
              if (i <= this.pageCount) {
                //console.log("UP:", i);
                await this.paginationArray.push(i);
                //console.log("PAGINATION UP ARRAY:", this.paginationArray);
              }
            }
            var j;
            for (j = this.currentPage - 1; j > this.currentPage - 3; j--) {
              if (j > 0) {
                //console.log("DOWN:", j);
                await this.paginationArray.push(j);
                //console.log("PAGINATION DOWN ARRAY:", this.paginationArray);
              }
            }
          }
          if (this.currentPage + 1 <= this.pageCount + 1) {
            this.nextPage = this.currentPage + 1;
          }
          if (this.currentPage - 1 > 1) {
            this.prevPage = this.currentPage - 1;
          }
          //console.log("NEXT PAGE:", this.nextPage);
          //console.log("PREV PAGE:", this.prevPage);
          this.paginationArray = _.sortBy(this.paginationArray);
          //console.log("PAGINATION", this.paginationArray);

          this.loadingOverlay = false;
          this.loadingText = null;
          return;
        }
        this.loadingText = "There was an error loading. Refresh page.";
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async pageNavigation(navPage) {
      try {
        navPage = Number(navPage);
        //console.log("NAVIGATING NEXT PAGE:", navPage);
        let newUrl = `/influencer-campaign/list/${this.campaignId}`;
        let queryArray = [];
        if (!isNaN(navPage)) {
          //console.log("NAV PAGING!");
          queryArray.push(`page=${navPage}`);
        }
        if (typeof this.$route.query.view !== "undefined") {
          queryArray.push(`view=${this.listView}`);
        }

        if (queryArray.length > 0) {
          let queryString = queryArray.join("&");
          newUrl = `${newUrl}/?${queryString}`;
        }
        this.$router.push(newUrl);
        this.loadInfluencerCandidates();
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },

    async addInfluencer() {
      this.addInfluencerAlert = false;
      this.addInfluencerAlertMsg = null;
      try {
        if (
          this.model.newInfluencer == null ||
          this.model.newInfluencer.trim() == "" ||
          typeof this.model.newInfluencer == "undefined"
        ) {
          this.addInfluencerAlert = true;
          this.addInfluencerAlertMsg = "Missing Instagram profile.";
          return;
        }
        //if ((await this.$validator.validateAll()) === true) {
        //console.log("PROFILE CHECK SUCCESSFUL");
        let influencerData = {};
        influencerData.instagram = this.model.newInfluencer;
        influencerData.usertoken = this.auth;
        influencerData.campaign = this.campaignId;
        //console.log("CANDIDATE API:", influencerCampaignCandidateAddApi)
        //console.log("SEND IMAGE:", influencerData);
        let addInfluencerResponse = await axios.post(
          influencerCampaignCandidateAddApi,
          influencerData
        );
        //console.log("INFLUENCER RESPONSE:", addInfluencerResponse.data);
        if (addInfluencerResponse.data.success === true) {
          this.instagram = null;
          this.addInfluencerModal = false;
          this.alertMsg = "Profile added successfully.";
          this.displayAlert = true;
          this.alertType = "success";
          this.$router.push(`/influencer-campaign/list/${this.campaignId}/?view=pending`)
          this.loadInfluencerCandidates();
          return;
        }
        if (addInfluencerResponse.data.success === false) {
          this.addInfluencerAlert = true;
          this.addInfluencerAlertMsg = addInfluencerResponse.data.message;
          return;
        }

        return;
        //}
        //console.log("CHECK FAILED");
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
        this.addInfluencerAlert = true;
        this.addInfluencerAlertMsg = "Error: Refresh and try Again";
        return;
      }
    },
    async cancelAddInfluencer() {
      this.instagram = null;
      this.addInfluencerModal = false;
    },
    async showAddInfluencerModal() {
      this.instagram = null;
      this.addInfluencerAlert = false;
      this.addInfluencerAlertMsg = null;
      this.model.newInfluencer = null;
      this.addInfluencerModal = true;
    },
    async showApproveModal() {
      this.approveModal = true;
    },
    async showRejectModal() {
      this.rejectModal = true;
    },
    async approveSelected() {
      //alert(value);
      //alert(this.setStatus);
      this.approveModal = false;
      //alert(`APPROVING INFLUENCERS: ${this.setStatus}`);
      //console.log("APPROVING: ", this.setStatus);
      let approveInfluencersResponse = await axios.post(
        influencerCandidateUpdateStatusBatchApi,
        {
          usertoken: this.auth,
          profiles: this.setStatus,
          status: "approved",
          client: this.campaignData.clientId,
          campaign: this.campaignId,
        }
      );
      /*console.log(
        "UPDATE STATUS APPROVE RESPONSE: ",
        approveInfluencersResponse.data
      );*/
      if (approveInfluencersResponse.data.success === true) {
        await this.loadInfluencerCandidates();
        //this.campaignCandidateList = approveInfluencersResponse.data.result;
        this.setStatus = [];
      }
    },
    async rejectSelected() {
      //alert(value);
      //console.log("REJECTING: ", this.setStatus);
      this.rejectModal = false;
      // alert(`REJECTING INFLUENCERS: ${this.setStatus}`);
      let rejectInfluencersResponse = await axios.post(
        influencerCandidateUpdateStatusBatchApi,
        {
          usertoken: this.auth,
          profiles: this.setStatus,
          status: "rejected",
          client: this.campaignData.clientId,
          campaign: this.campaignId,
        }
      );
      /*console.log(
        "UPDATE STATUS REJECTED RESPONSE: ",
        rejectInfluencersResponse.data
      );*/
      if (rejectInfluencersResponse.data.success === true) {
        await this.loadInfluencerCandidates();
        //this.campaignCandidateList = rejectInfluencersResponse.data.result;
        this.setStatus = [];
      }
    },
    async igProfileCheck() {
      try {
        let profileName = this.model.instagram.replace(/[^a-zA-Z0-9_.]/g, "");
        if (typeof profileName === "undefined") {
          //this.igRules = ["Please enter a profile"];
          this.validInstagram = false;
          return false;
        }
        let igCheckResponse = await IGProfileData.getProfileDataDirect(
          profileName
        );

        if (igCheckResponse.success === false) {
          //this.igRules = ["Please enter a valid profile"];
          this.validInstagram = false;
          return false;
        }

        //console.log("VALID PROFILE");
        //this.igRules = [true];
        //console.log("CHECKING INSTAGRAM", igCheckResponse.result);
        this.validInstagram = true;
        return igCheckResponse.result;
      } catch (err) {
        //console.log("THERE WAS AN ERROR", err);
        this.igRules = ["Please check Instagram profile."];
        this.validInstagram = false;
        return false;
      }
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.campaignId = this.$route.params.campaignId;
    this.loadCampaign();
  },
  created() {
    let self = this;
    try {
      if (typeof this.$route.query.view !== "undefined") {
        this.listView = this.$route.query.view;
      }
    } catch (err) {
      console.log("THERE WAS AN ERROR:", err);
    }

    this.$validator.extend("instagramCheck", {
      getMessage(field, val) {
        return "Invalid instagram";
      },
      validate(value, field) {
        //console.log("VALUE:", value);
        //console.log("FIELD:", field);

        try {
          let profileName = value.replace(/[^a-zA-Z0-9_.]/g, "");

          if (typeof profileName === "undefined") {
            //console.log("NO PROFILE NAME");
            return false;
          }
          return IGProfileData.getProfileDataDirect(profileName).then(
            (igCheckResponse) => {
              /*console.log(
                "CHECKING INSTAGRAM VEE VALIDATE",
                igCheckResponse.result
              );*/
              if (igCheckResponse.success === false) {
                //return false;
                //console.log("NOT VALID INSTAGRAM :(");
                // resolve(false);
                return false;
              } else {
                //console.log("VALID INSTAGRAM :)");
                //return igCheckResponse.result;
                return true;
                //resolve(true);
              }
            }
          );
        } catch (err) {
          //console.log("THERE WAS AN ERROR:", err);
          return false;
        }

        return end > start;
      },
    });
  },
};
</script>

<style scoped>
.influencer-img {
  width: 50px;
  margin: 10px;
  border-radius: 5px;
}
</style>